import axios from "axios";
import Button from "../../components/button";
import { useEffect, useMemo, useRef, useState } from "react";
import { db } from "src/firebase/firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";

const VerificataionLimit = () => {
  const [account, setAccount] = useState(null);
  const [identityLoading, setIdentityLoadng] = useState(false);
  const [addressLoading, setAddressLoadng] = useState(false);
  const [identityVerification, setIdentityVerification] = useState("Verify");
  const [addressVerification, setAddressVerification] = useState("Verify");

  useEffect(() => {
    getAccountInfo();
  }, []);

  const getAccountInfo = async () => {
    let account: any = localStorage.getItem("account");
    account = JSON.parse(account);
    const q = await query(
      collection(db, "Accounts"),
      where("email", "==", account?.email?.toLowerCase())
    );

    const querySnapshot = await getDocs(q);
    if (querySnapshot.docs.length > 0) {
      let _account = querySnapshot.docs[0].data();

      if (querySnapshot.docs.length) {
        localStorage.setItem("account", JSON.stringify(_account));
        setAccount(_account);
        console.log(_account)
        if (_account?.identity) {
          setIdentityVerification("Verified");
        } else if (_account?.extensive_screening_check_id || _account?.enhanced_identity_check_id || _account?.document_check_id) {
          setIdentityVerification("Pending");
        }
        if (_account?.addressPermit) {
          setAddressVerification("Verified");
        } else if (_account?.proof_of_address_check_id) {
          setAddressVerification("Pending");
        }
      }
    }
  };

  const getToken = async (clientId: string) => {
    const result = await axios({
      method: "post",
      url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/getToken",
      data: {
        id: clientId,
      },
    });
    return result;
  };

  const identityStage = () => {
    let stages = [];
    return stages = [
      {
        name: "intro",
        options: {
          heading: "We need to verify your identity",
          message: [
            "In order to open an account, we need to check a few things.",
            "This will take only a moment",
          ],
          startButtonText: "Start Verification",
        },
      },

      "userConsentCapture",
      {
        name: "documentCapture",
        options: {
          documentTypes: {
            passport: false,
            driving_license: false,
            national_identity_card: true,
            residence_permit: false,
          },
        },
      },

      {
        name: "faceCapture",
        options: {
          mode: "video"
        },
      },

      {
        name: "completion",
        options: {
          heading: "Thank you for completing the process",
          message: ["we will get in touch shortly"],
        },
      },
    ]
  }

  const proofOfResidenceStage = () => {
    let stages = [];
    return stages = [
      {
        name: "intro",
        options: {
          heading: "We need to verify your identity",
          message: [
            "In order to open an account, we need to check a few things.",
            "This will take only a moment",
          ],
          startButtonText: "Start Verification",
        },
      },

      "userConsentCapture",
      {
        name: "documentCapture",
        options: {
          documentTypes: {
            passport: false,
            driving_license: false,
            national_identity_card: false,
            residence_permit: true,
          },
        },
      },

      {
        name: "poaCapture",
        options: {
          documentTypes: {
            bank_statement: true,
            utility_bill: false,
          },
        },
      },

      {
        name: "completion",
        options: {
          heading: "Thank you for completing the process",
          message: ["we will get in touch shortly"],
        },
      },
    ]
  }

  const mountCard = async (type, token, clientId) => {
    let complyCubeInstance;
    setIdentityLoadng(false);
    setAddressLoadng(false);
    complyCubeInstance = await window.ComplyCube.mount({
      token: token,
      stages: type === 'identity' ? identityStage() : proofOfResidenceStage(),
      // stages: [
      //   {
      //     name: "intro",
      //     options: {
      //       heading: "We need to verify your identity",
      //       message: [
      //         "In order to open an account, we need to check a few things.",
      //         "This will take only a moment",
      //       ],
      //       startButtonText: "Start Verification",
      //     },
      //   },

      //   "userConsentCapture",
      //   {
      //     name: "documentCapture",
      //     options: {
      //       documentTypes: {
      //         passport: false,
      //         driving_license: false,
      //         national_identity_card: type === "identity",
      //         residence_permit: type === "address",
      //       },
      //     },
      //   },

      //   // {
      //   //   name: "faceCapture",
      //   //   options: {
      //   //     mode: "video"
      //   //   },
      //   // },

      //   {
      //     name: "completion",
      //     options: {
      //       heading: "Thank you for completing the process",
      //       message: ["we will get in touch shortly"],
      //     },
      //   },
      // ],
      onComplete: function (data) {
        console.log("Capture complete", data);
        console.log("Capture complete", data.documentCapture.documentId);

        // First set a check with client Id and document ID.

        //pass proof_of_address_check  when type === "address" in the API
        let checkObjExtensiveScreeningCheck = {}
        let checkObjEnhancedIdentity = {}
        let checkObjDocumentCheck = {}
        let checkObjProofOfAddressCheck = {}
        if (type === 'identity') {
          checkObjExtensiveScreeningCheck = {
            clientId: clientId,
            type: "extensive_screening_check",
          }

          checkObjEnhancedIdentity = {
            clientId: clientId,
            documentId: data.documentCapture.documentId,
            type: "enhanced_identity_check",
            liveVideoId: data.faceCapture.liveVideoId
          }

          checkObjDocumentCheck = {
            clientId: clientId,
            documentId: data.documentCapture.documentId,
            type: "document_check",
          }

          var _account = {
            ...account,
            clientId: clientId,
            extensive_screening_check_id: '',
            enhanced_identity_check_id: '',
            document_check_id: '',
          };


          axios({
            method: "post",
            url: `https://us-central1-vizioncrypto-379118.cloudfunctions.net/performCheck`,
            data: checkObjExtensiveScreeningCheck,
          }).then(async (resp) => {
            console.log("checkObjExtensiveScreeningCheck", resp);
            console.log("account", _account);
            _account.extensive_screening_check_id = resp.data.id

            axios({
              method: "post",
              url: `https://us-central1-vizioncrypto-379118.cloudfunctions.net/performCheck`,
              data: checkObjEnhancedIdentity,
            }).then(async (resp) => {
              console.log("checkObjEnhancedIdentity", resp)
              console.log("account", _account);
              _account.enhanced_identity_check_id = resp.data.id

              axios({
                method: "post",
                url: `https://us-central1-vizioncrypto-379118.cloudfunctions.net/performCheck`,
                data: checkObjDocumentCheck,
              }).then(async (resp) => {
                console.log("account", _account);
                console.log("checkObjDocumentCheck", resp);
                _account.document_check_id = resp.data.id
                await setDoc(doc(db, "Accounts", account.id), _account);
                setAccount({ ..._account });
                localStorage.setItem("account", JSON.stringify(_account));
              }).catch((error) => {
                console.log(error)
              })

            }).catch((error) => {
              console.log(error)
            })
          }).catch((error) => {
            console.log(error)
          })
          complyCubeInstance.unmount();

        }

        if (type === 'address') {
          checkObjProofOfAddressCheck = {
            clientId: clientId,
            type: "proof_of_address_check",
            documentId: data.poaCapture.documentId,
          }

          var _account = {
            ...account,
            clientId: clientId,
            proof_of_address_check_id: ''
          }

          axios({
            method: "post",
            url: `https://us-central1-vizioncrypto-379118.cloudfunctions.net/performCheck`,
            data: checkObjProofOfAddressCheck,
          }).then(async (resp) => {
            console.log("checkObjProofOfAddressCheck", resp)
            _account.proof_of_address_check_id = resp.data.id
            await setDoc(doc(db, "Accounts", account.id), _account);
            setAccount({ ..._account });
            localStorage.setItem("account", JSON.stringify(_account));
          })
        }




        complyCubeInstance.unmount();

        // axios({
        //   method: "post",
        //   url: `https://us-central1-vizioncrypto-379118.cloudfunctions.net/performCheck`,
        //   data: checkObj,
        // }).then(async (resp) => {
        //   const _account = {
        //     ...account,
        //     clientId: clientId,
        //     identityCheckId:
        //       type === "identity"
        //         ? resp.data.id
        //         : account?.identityCheckId ?? "",
        //     addressCheckId:
        //       type === "address" ? resp.data.id : account?.addressCheckId ?? "",
        //   };
        //   await setDoc(doc(db, "Accounts", account.id), _account);
        //   setAccount({ ..._account });
        //   localStorage.setItem("account", JSON.stringify(_account));
        //   complyCubeInstance.unmount();
        // });
      },
      onModalClose: () => {
        complyCubeInstance.unmount();
      },
    });
  };

  const createClient = async () => {
    const data: any = await axios({
      method: "post",
      url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/createtoken",
      data: {
        type: "person",
        email: account?.email,
        personDetails: {
          firstName: account?.firstName,
          lastName: account?.lastName,
          dob: "",
        },
      },
    });
    if (data) {
      const _account = {
        ...account,
        clientId: data?.data?.id,
      };
      await setDoc(doc(db, "Accounts", account.id), _account);
      setAccount({ ..._account });
      localStorage.setItem("account", JSON.stringify(_account));
    }
    return data;
  };

  async function startVerification(type, value) {
    try {
      let result;

      if (account?.clientId) {
        result = await getToken(account?.clientId);
        mountCard(type, result?.data?.token, account?.clientId);
      } else {
        const _result: any = await createClient();
        const _token: any = await getToken(_result.data.id);
        mountCard(type, _token?.data?.token, _result.data.id);
      }
    } catch (error) {
      console.error("Error starting verification:", error);
      setAddressLoadng(false);
      setIdentityLoadng(false);
    }
  }

  const getIdentityVerification = async () => {
    let account: any = localStorage.getItem("account");
    account = JSON.parse(account);
    var identityCheckTypes = {
      extensive_screening_check: false,
      enhanced_identity_check: false,
      document_check: false,
    };

    if (account?.extensive_screening_check_id && account?.enhanced_identity_check_id && account?.document_check_id && !account?.identity) {
      await axios({
        method: "post",
        url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/check",
        data: {
          id: account.extensive_screening_check_id,
        },
      }).then((extensive_screening_check_result) => {
        if (extensive_screening_check_result.data.items.length > 0) {
          const check = extensive_screening_check_result.data.items.find(
            (item) => item.id === account.extensive_screening_check_id
          );
          console.log(check)
          if (check && check.status === "complete") {
            identityCheckTypes.extensive_screening_check = true;
          }
        }

        axios({
          method: "post",
          url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/check",
          data: {
            id: account.enhanced_identity_check_id,
          },
        }).then((enhanced_identity_check_result) => {
          if (enhanced_identity_check_result.data.items.length > 0) {
            const check = enhanced_identity_check_result.data.items.find(
              (item) => item.id === account.enhanced_identity_check_id
            );
            console.log(check)
            if (check && check.status === "complete") {
              identityCheckTypes.enhanced_identity_check = true;
            }
          }


          axios({
            method: "post",
            url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/check",
            data: {
              id: account.document_check_id,
            },
          }).then(async (document_check_result) => {
            if (document_check_result.data.items.length > 0) {
              const check = document_check_result.data.items.find(
                (item) => item.id === account.document_check_id
              );
              console.log(check)
              if (check && check.status === "complete") {
                identityCheckTypes.document_check = true;
                console.log(identityCheckTypes, account)
                if (identityCheckTypes.extensive_screening_check && identityCheckTypes.enhanced_identity_check && identityCheckTypes.document_check) {
                  setIdentityVerification("Verified");
                  const _account = {
                    ...account,
                    accountLimit: 3000,
                    identity: true,
                  };
                  await setDoc(doc(db, "Accounts", account.id), _account);
                  setAccount({ ..._account });
                  localStorage.setItem("account", JSON.stringify(_account));
                } else {
                  setIdentityVerification("Pending");
                }

              }
            }
          }).catch((error) => {
            setIdentityVerification("Pending");
          });

        }).catch((error) => {
          setIdentityVerification("Pending");
        });

      }).catch((error) => {
        setIdentityVerification("Pending");
      });






      //




      //









      // const result = await axios({
      //   method: "post",
      //   url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/check",
      //   data: {
      //     id: account.extensive_screening_check_id,
      //   },
      // });
      // if (result.data.items.length > 0) {
      //   const check = result.data.items.find(
      //     (item) => item.id === account.extensive_screening_check_id
      //   );
      //   console.log(check)
      //   if (check && check.status === "complete") {
      //     setIdentityVerification("Verified");
      //     const _account = {
      //       ...account,
      //       accountLimit: 3000,
      //       identity: true,
      //     };
      //     await setDoc(doc(db, "Accounts", account.id), _account);
      //     setAccount({ ..._account });
      //     localStorage.setItem("account", JSON.stringify(_account));
      //   } else {
      //     setIdentityVerification("Pending");
      //   }
      // }
    }
    if (account?.proof_of_address_check_id && !account?.addressPermit) {
      axios({
        method: "post",
        url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/check",
        data: {
          id: account.proof_of_address_check_id,
        },
      }).then(async (proof_of_address_check_result) => {
        if (proof_of_address_check_result.data.items.length > 0) {
          const check = proof_of_address_check_result.data.items.find(
            (item) => item.id === account.proof_of_address_check_id
          );
          if (check && check.status === "complete") {
            setAddressVerification("Verified");
            setIdentityVerification("Verified");
            const _account = {
              ...account,
              accountLimit: 10000,
              addressPermit: true,
            };
            await setDoc(doc(db, "Accounts", account.id), _account);
            setAccount({ ..._account });
            localStorage.setItem("account", JSON.stringify(_account));
          } else {
            setAddressVerification("Pending");
          }
        }
      }).catch((error) => {
        setAddressVerification("Pending");
      })

    }
  };

  useEffect(() => {
    getIdentityVerification();
  }, [account]);

  // const identityVerification = useMemo(async () => {
  //   const result = await getIdentityVerification();
  //   return "Verify";
  // }, [account]);

  return (
    <div className="p-3">
      <div className="flex gap-3 items-center">
        <h5 className="font-semibold">Current Account Limit:</h5>
        <span>{account?.accountLimit}</span>
      </div>
      <div className="mt-5">
        <p>
          1- To access $3000 daily limit it will have a link that leads to
          comply cube to do
        </p>
        <ul className="list-decimal pl-[40px]">
          <li className="text-sm font-semibold">Document Check</li>
          <li className="text-sm font-semibold">Identity & liveness check</li>
          <li className="text-sm font-semibold">Enhanced Identity Check</li>
        </ul>
        <Button
          className="ml-[40px] mt-2"
          onClick={() => {
            startVerification("identity", 3000);
            setIdentityLoadng(true);
          }}
          disabled={identityVerification === "Verified"}
          loading={identityLoading}
        >
          {identityVerification}
        </Button>
      </div>

      <div className="mt-5">
        <p>
          2-To access $10,000 daily limit it will have a link that leads to
          comply cube to do
        </p>
        <ul className="list-decimal pl-[40px]">
          <li className="text-sm font-semibold">Proof of Address Check</li>
        </ul>
        <Button
          className="ml-[40px] mt-2"
          onClick={() => {
            startVerification("address", 10000);
            setAddressLoadng(true);
          }}
          // disabled={account?.addressPermit === true ? true : false}
          disabled={addressVerification === "Verified"}
          loading={addressLoading}
        >
          {addressVerification}
        </Button>
      </div>

      <div className="mt-5">
        <p>
          3-To access $10,000 + limit it will tell them to contact support on
          telegram @vizion or to email
        </p>
        <ul className="list-decimal pl-[40px]">
          <li className="text-sm font-semibold">support@lbdigital.info</li>
        </ul>
      </div>
      <div id="complycube-mount" className="z-[9999]"></div>
    </div>
  );
};
export default VerificataionLimit;
